var map = {
	"./history/history": 1091,
	"./history/history.js": 1091,
	"./htmldiff": 412,
	"./htmldiff-base": 591,
	"./htmldiff-base.js": 591,
	"./htmldiff.css": 1503,
	"./htmldiff.js": 412,
	"./process/process": 1092,
	"./process/process.js": 1092,
	"./process/process.png": 2533
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4778;